import { RadioGroup } from "components/Atoms/inputs/RadioGroup";
import { FilterByTypes } from "embedshowswizard/models";
import React from "react";

interface Props {
  filterType: FilterByTypes
  onChange: (newValue: FilterByTypes) => void
}

export const FilterByRadio = (props: Props) => {
  const permanentOptions = [{
    label: RESX.GeneralLabels.All,
    value: "AllArtists"
  }, {
    label: RESX.NotificationSettings.OnlyASelectionOfArtists,
    value: "MultipleArtists"
  }];
  const productionOption = {
    label: RESX.Tour.SelectionOfTours,
    value: "Productions"
  };
  const options = site.currentEnvironment.production.enabled ? [...permanentOptions, productionOption] : permanentOptions;

  return <RadioGroup
    orientation="vertical"
    options={options}
    value={props.filterType}
    onChange={(value) => props.onChange(value as FilterByTypes)}
  />
}